<template>
  <div class="modal fade" :id="id" tabindex="-1">
    <div class="modal-dialog modal-xl modal-dialog-scrollable">
      <form class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ formData.email_id ? $t('mail.ans_message') : $t('mail.new_message') }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="loadForm">
                <span class="svg-icon svg-icon-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                          fill="currentColor" />
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                          fill="currentColor" />
                  </svg>
                </span>
            </div>
          </div>
          <div class="modal-body scroll-y" style="max-height: 70vh">
            <div class="row mt-5">
              <div class="col-12 col-md-8 col-lg-8">
                <div class="row d-flex align-items-center">
                  <div class="col-12 col-md-2 col-lg-2">
                    <h4>{{$t('mail.a')}} <span class="text-danger">*</span></h4>
                  </div>
                  <div class="col-12 col-md-10 col-lg-10">
                    <TagInput
                        containerClass="form-group mb-5"
                        :inputClass="'form-control form-control-lg form-control-solid'"
                        v-model="formData.to"
                        :parent-id="'#'+id"
                        type="email"
                        :name="`${id}-to-${count}`"
                        :helper-text="$t('invoice.help_mail_tag')"
                        :existingTags="contactSuggestions"
                        :is-required="true"
                    />
                  </div>
                </div>

                <div class="row align-items-center" v-show="showCc">
                  <div class="col-12 col-md-2 col-lg-2">
                    <h4>{{$t('mail.cc')}} <i class="fa fa-minus-circle fs-4 ms-3 cursor-pointer" @click.stop="showCc = false" style="color: #303D4E;"></i></h4>
                  </div>
                  <div class="col-12 col-md-10 col-lg-10">
                    <TagInput
                        containerClass="form-group mb-5"
                        type="email"
                        :inputClass="'form-control form-control-lg form-control-solid'"
                        v-model="formData.cc"
                        :parent-id="'#'+id"
                        :name="`${id}-cc-${count}`"
                        :helper-text="$t('invoice.help_mail_tag')"
                        :existingTags="contactSuggestions"
                    />
                  </div>
                </div>

                <div class="row align-items-center" v-show="showCci">
                  <div class="col-12 col-md-2 col-lg-2">
                    <h4>CCi <i class="fa fa-minus-circle fs-4 ms-3 cursor-pointer" @click.stop="showCci = false" style="color: #303D4E;"></i></h4>
                  </div>
                  <div class="col-12 col-md-10 col-lg-10">
                    <TagInput
                        containerClass="form-group mb-5"
                        type="email"
                        :inputClass="'form-control form-control-lg form-control-solid'"
                        v-model="formData.bcc"
                        :parent-id="'#'+id"
                        :name="`${id}-bcc-${count}`"
                        :helper-text="$t('invoice.help_mail_tag')"
                        :existingTags="contactSuggestions"
                    />
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-4 col-lg-4">
                <div class="d-flex justify-content-between align-items-center mt-5">
                  <div class="d-flex align-items-center">
                    <div class="d-flex align-items-center me-5" v-if="!showCc">
                      <i class="fa fa-plus-circle fs-4 me-3 cursor-pointer" @click.stop="showCc = true" style="color: #303D4E;"></i>
                      <h5 class="mt-1">{{$t('mail.cc')}}</h5>
                    </div>
                    <div class="d-flex align-items-center" v-if="!showCci">
                      <i class="fa fa-plus-circle fs-4 me-3 cursor-pointer" @click.stop="showCci = true" style="color: #303D4E;"></i>
                      <h5 class="mt-1">CCi</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row border-bottom">
              <div :class="showDate ? 'col-12 col-md-8 col-lg-8' : 'col-12'">
                <div class="row align-items-center">
                  <div :class="showDate ? 'col-12 col-md-2 col-lg-2' : 'col-12 col-md-1 col-lg-1'">
                    <h4>{{$t('mail.subject')}} <span class="text-danger">*</span></h4>
                  </div>
                  <div :class="showDate ? 'col-12 col-md-10 col-lg-10' : 'col-12 col-md-11 col-lg-11'">
                    <Input
                        container-class="form-group mb-5"
                        :name="`subject`+ id"
                        type="text"
                        :inputClass="'form-control form-control-lg form-control-solid'"
                        size="lg"
                        v-model="formData.subject"
                        :is-required="true"
                    />
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-4 col-lg-4" style="margin-top: -20px;">
                <InputDate
                    :name="'date'+id"
                    type="text"
                    :label="$t('mail.choose_date')"
                    labelClass="form-label fs-6 text-black"
                    :inputClass="'form-control form-control-sm form-control-solid'"
                    :isRequired="showDate"
                    v-if="showDate"
                    size="lg"
                    :placeholder="$t('mail.date')"
                    containerClass="form-group mb-5"
                    dateFormat="yyyy-MM-dd HH:mm"
                    :enableTime="true"
                    v-model="formData.scheduled_at"
                    :enablePassTime="false"
                    :clearable="true"
                />
              </div>
            </div>

            <div class="row mt-5">
              <div class="col-12 col-md-8 col-lg-8">
                <CKEditor
                    :id="'mail-editor'+id"
                    container-class="h-400px"
                    :content="formData.message"
                    @text="getDescription"
                    ref="ckeditor"
                    @ready="onEditorReady"
                />
              </div>

              <div class="col-12 col-md-4 col-lg-4">
                <div class="card border_style">
                  <div class="card-header">
                    <div class="d-flex align-items-center">
                      <h2>{{$t('pipelines.attach_files')}}</h2>
                      <span class="badge badge-light-warning fs-2 mb-2 ms-3">{{fileCount}}</span>
                    </div>
                  </div>
                  <div class="card-body p-5">
                    <div style="overflow-y: auto; max-height: 280px !important;">
                      <UploadFile :id="'upload_file2'+id" :size="2" :number="20" v-model="formData.attachments"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br>
            <ul class="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6 mt-15">
              <li class="nav-item">
                <a class="nav-link active" data-bs-toggle="tab" :href="'#kt_settings'+id">{{ $t("menu.settings") }}</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" data-bs-toggle="tab" :href="'#kt_signature'+id">{{ $t("menu.signature") }}</a>
              </li>
            </ul>
            <div class="tab-content mb-5" id="myTabContent">
              <div class="tab-pane fade show active" :id="'kt_settings'+id" role="tabpanel">
                <div class="d-flex align-items-center gap-4">
                  <div class="form-check me-5 mt-2">
                    <input class="form-check-input" type="checkbox" v-model="formData.request_receipt" id="flexCheckDefault"/>
                    <label class="ms-2 form-label fs-6 text-black" for="flexCheckDefault">
                      {{ $t('mail.request_receipt') }}
                    </label>
                  </div>
                  <div class="d-flex align-items-center gap-3 mt-1">
                    <span class="me-2 form-label fs-6 text-black mt-1">{{ $t('mail.priority') }}</span>
                    <Select2
                        :parent-id="`#${id}`"
                        containerClass="col-12"
                        :name="`${id}-priority`"
                        :multiple="false"
                        selectClass="form-select-sm form-select-solid form-control-sm"
                        :isRequired="false"
                        :placeholderText="$t('mail.priority')"
                        v-model="formData.priority"
                    >
                      <option v-for="(priority, index) in priorities" :key="index" :value="priority.value">
                        {{ priority[locale] }}
                      </option>
                    </Select2>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade" :id="'kt_signature'+id" role="tabpanel">
                <div class="d-flex align-items-center gap-3">
                  <span class="me-2 form-label fs-6 text-black">{{ $t('menu.select_signature') }}</span>
                  <Select2
                      :parent-id="`#${id}`"
                      containerClass="col-6"
                      :name="`${id}-signature`"
                      :multiple="false"
                      selectClass="form-select-sm form-select-solid form-control-sm"
                      :isRequired="false"
                      :placeholderText="$t('menu.select_signature')"
                      v-model="selectedSignature"
                      :IsInputGroup="true"
                      icon="bi bi-plus"
                      :clickAddon="openSignatureModal"
                      :clear="true"
                  >
                    <option v-for="(signature, index) in signatures" :key="index" :value="signature.id">
                      {{ signature.name }}
                    </option>
                  </Select2>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer mt-20">
            <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="loadForm"></Button>
            <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" @click.prevent="submitForm(false)" btn-text="button.send" size="7px 30px" :is-disabled="!formData.to || !formData.to.length" :is-loading="isLoading"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>

  <SignatureModal :id="'create_signature_modal'+id" @load="loadData" :parent="id"/>
</template>

<script setup>
import {ref, defineEmits, defineProps, watch, computed, onMounted} from "vue";
import Input from "@/components/Input.vue";
import {useStore} from "vuex";
import Button from "@/components/Button.vue"
import CKEditor from '@/components/CKEditor.vue';
import UploadFile from "@/components/UploadFile";
import TagInput from "@/components/TagifyInput.vue";
import Select2 from "@/components/Select2";
import {useLocales} from "@/composables/locales";
import { useRoute } from "vue-router"
import SignatureModal from "./SignatureModal.vue"
import InputDate from "@/components/InputDate.vue";

const store = useStore()
const {locale} = useLocales()

const props = defineProps({
  id: {
    type: String,
    required: true
  },
  form: {
    type: Object,
    default: {
      to: [],
      cc: [],
      bcc: [],
      subject: '',
      message: '',
      attachments: [],
      email_id: '',
      scheduled_at: '',
      priority: '3 (Normal)',
      request_receipt: false,
      is_draft: false
    }
  },
})
const emits = defineEmits(['load', 'reply'])

const isLoading = ref(false)
const showCc = ref(false)
const showCci = ref(false)
const showDate = ref(false)
const selectedSignature = ref('')
const oldSelectedSignature = ref('')
const ckeditor = ref(null)
const count = ref(0)

const formData = ref({})
const contacts = computed(() => store.getters['mails/getUserContacts'])
const priorities = computed(() => store.getters['mails/getPriorities'])
const activeSignature = computed(() => store.getters['mails/getActiveSignature'])
const signatures = computed(() => store.getters['mails/getSignatures'])
const fileCount = computed(() => formData.value.attachments?.length || 0)

const contactSuggestions = computed(() => {
  return contacts.value
      ?.filter(item => item.email)
      .map(item => {
        return `${item.fullname} <${item.email}>`;
      }) || [];
});

const removeElt = computed(() => {
  return signatures.value?.find(item => item.id === oldSelectedSignature.value);
});

const isDraft = computed(() => {
  if (ckeditor.value && ckeditor.value.editorInstance) {
    const editor = ckeditor.value.editorInstance
    const data = editor.getData().trim()
    const signatureHtml = `<p style="text-align: right;">${activeSignature.value?.content || ''}</p>`.trim()

    const parser = new DOMParser()
    const docContent = parser.parseFromString(data, 'text/html').body.textContent?.trim()
    const docSignature = parser.parseFromString(signatureHtml, 'text/html').body.textContent?.trim()

    if (docContent && docContent !== '' && docContent !== docSignature) {
      return true
    }

    return false
  }
})

watch(() =>
    props.form, () => {
  formData.value = JSON.parse(JSON.stringify(props.form));

  if(activeSignature.value?.id) {
    const signatureHtml = `<p><br><br></p><p>${activeSignature.value?.content || ''}</p><p><br><br></p>`
    formData.value.message = signatureHtml + formData.value.message
  }


  formData.value.to = [...(props.form.to || [])];

  if(props.form.cc.length > 0 && props.form.email_id) {
    showCc.value = true
  }else {
    showCc.value = false
  }
  if(props.form.bcc.length > 0 && props.form.email_id) {
    showCci.value = true
  }else {
    showCci.value = false
  }
  count.value++
}, {deep: true, immediate: true});

function getDescription(text) {
  if (formData.value.message !== text) {
    formData.value.message = text;
  }
}

watch(() => activeSignature.value, (value) => {
  if(value) {
    selectedSignature.value = activeSignature.value.id
  }
});

watch(() => selectedSignature.value, (newVal, oldVal) => {
  if (newVal !== oldVal) {
    oldSelectedSignature.value = oldVal;
    if (oldSelectedSignature.value && removeElt.value) {
      removeSignature(removeElt.value.content);
    }
    if(newVal){
      changeSignature();
    }
  }
});

function changeSignature() {

  if(selectedSignature.value) {
    store.dispatch('mails/selectSignature', selectedSignature.value).then((response) => {
      store.dispatch('mails/loadActiveSignatures').then((res) => {
        insertSignature(activeSignature.value?.content)
        removeEmptyParagraphs()
      })
    })
  }
}

function openSignatureModal(){
  closeModal()
  $('#create_signature_modal'+props.id).modal('toggle')
}

function onEditorReady(editor) {
  ckeditor.value.editorInstance = editor;
}

function insertSignature(variableText, currentContent = '') {
  if (!ckeditor.value || !ckeditor.value.editorInstance) return;

  const editor = ckeditor.value.editorInstance;

  let htmlSignature = '';

  if (currentContent)
    htmlSignature += currentContent;

  htmlSignature += `<br><p>${variableText}</p><br><br><br><br><br><br><br>`;

  const viewFragment = editor.data.processor.toView(htmlSignature);
  const modelFragment = editor.data.toModel(viewFragment);

  editor.model.change(writer => {
    const root = editor.model.document.getRoot();
    const currentHtml = editor.getData();

    const hasReply = currentHtml.includes('<blockquote');

    if (hasReply) {
      const children = Array.from(root.getChildren());

      for (let i = 0; i < children.length; i++) {
        const el = children[i];

        if (el.name === 'blockQuote' && i > 0 && children[i - 1].name === 'paragraph') {
          const paragraphBefore = children[i - 1];
          const insertPosition = editor.model.createPositionBefore(paragraphBefore);

          const spacer = writer.createElement('paragraph');
          writer.insertText('', spacer, 0);
          editor.model.insertContent(spacer, insertPosition);

          editor.model.insertContent(modelFragment, insertPosition);
          writer.setSelection(insertPosition);
          return;
        }
      }

      const firstBlockquote = children.find(el => el.name === 'blockQuote');
      if (firstBlockquote) {
        const insertPosition = editor.model.createPositionBefore(firstBlockquote);

        const spacer = writer.createElement('paragraph');
        writer.insertText('', spacer, 0);
        editor.model.insertContent(spacer, insertPosition);

        editor.model.insertContent(modelFragment, insertPosition);
        writer.setSelection(insertPosition);
        return;
      }
    }

    const endPosition = editor.model.createPositionAt(root, 'end');
    const emptyParagraph = writer.createElement('paragraph');
    editor.model.insertContent(emptyParagraph, endPosition);

    const newEndPosition = editor.model.createPositionAt(root, 'end');
    editor.model.insertContent(modelFragment, newEndPosition);

    writer.setSelection(editor.model.createPositionAt(root, 'end'));
  });
}

function removeSignature(variableText) {
  if (!ckeditor.value || !ckeditor.value.editorInstance) return;

  const editor = ckeditor.value.editorInstance;
  const model = editor.model;

  const viewFragment = editor.data.processor.toView(variableText);
  const modelFragment = editor.data.toModel(viewFragment);

  model.change(writer => {
    const root = model.document.getRoot();
    const range = model.createRangeIn(root);

    const elementsToRemove = Array.from(modelFragment.getChildren());

    for (const element of elementsToRemove) {
      for (const item of range.getItems()) {
        if (!item.is('element')) continue;

        // 🔹 On ignore tout élément qui est dans un blockQuote
        let parent = item.parent;
        let insideBlockQuote = false;
        while (parent) {
          if (parent.is('element', 'blockQuote')) {
            insideBlockQuote = true;
            break;
          }
          parent = parent.parent;
        }
        if (insideBlockQuote) continue;

        const itemData = item.getChild(0)?.data?.trim();
        const elementData = element.getChild(0)?.data?.trim();

        if (item.name === element.name && itemData === elementData) {
          writer.remove(item);
          break;
        }
      }
    }
  });
}


function removeEmptyParagraphs() {
  if (!ckeditor.value || !ckeditor.value.editorInstance) return;

  const editor = ckeditor.value.editorInstance;
  const model = editor.model;
  const root = model.document.getRoot();

  model.change(writer => {
    const paragraphs = Array.from(root.getChildren()).filter(item =>
        item.is('element', 'paragraph')
    );

    for (const paragraph of paragraphs) {
      const textContent = Array.from(paragraph.getChildren())
          .map(child => child.data?.trim())
          .join('');

      if (!textContent || textContent === '\u00A0') {
        writer.remove(paragraph);
      }
    }
  });
}

function clearEditorContent() {
  if (!ckeditor.value || !ckeditor.value.editorInstance) return;

  const editor = ckeditor.value.editorInstance;

  editor.model.change(writer => {
    const root = editor.model.document.getRoot();

    for (const child of Array.from(root.getChildren())) {
      writer.remove(child);
    }

    const emptyParagraph = writer.createElement('paragraph');
    writer.insert(emptyParagraph, root, 'end');
    writer.setSelection(emptyParagraph, 'in');
  });
}

function closeModal(){
  $('#'+props.id).modal('toggle')
}

function loadForm() {
  if (isDraft.value && !formData.value.is_draft) {
    closeModal()
    submitForm(true)
  }else{
    if(!isDraft.value) closeModal()
    resetForm()
    clearEditorContent()
    changeSignature()
  }
}

function resetForm() {
  showCc.value = false
  showCci.value = false

  formData.value.to = []
  formData.value.subject = ''
  formData.value.message = ''
  formData.value.cc = []
  formData.value.bcc = []
  formData.value.attachments = []
  formData.value.scheduled_at = ''
  formData.value.priority = '3 (Normal)'
  formData.value.request_receipt = false
  formData.value.folder = ''
  formData.value.is_draft = false

  if(formData.value.email_id) emits('reply', false)
}

function formatArray(items){
  let data = []
  items.forEach(item => {
    const emailMatch = item.match(/<([^>]+)>/)
    if (emailMatch) {
      data.push(emailMatch[1])
    }else{
      data.push(item)
    }
  })
  return data
}

async function reply(draft=false) {
  isLoading.value = true;

  try {
    store.dispatch('mails/replyMail', {
      ...formData.value,
      to: formatArray(formData.value.to),
      cc: formatArray(formData.value.cc),
      bcc: formatArray(formData.value.bcc)
    }).then((res) =>{
      isLoading.value = false;
      emits('reply', isLoading.value)
      formData.value.email_id = ''
      loadForm()
      if(!draft) window.toastr['success'](i18n.global.t('mail.created_successfully'))
    }).finally(() => isLoading.value = false)
  }catch (e) {
  }
}

function sendMail(draft=false) {
  try {
    isLoading.value = true;

    store.dispatch('mails/createMail', {
      ...formData.value,
      to: formatArray(formData.value.to),
      cc: formatArray(formData.value.cc),
      bcc: formatArray(formData.value.bcc)
    }).then((res) => {
      formData.value.email_id = ''
      loadForm()
      if(!draft) window.toastr['success'](i18n.global.t('mail.created_successfully'))
    })
        .finally(() => isLoading.value = false)
  }catch (e) {
  }
}

async function submitForm(draft=false){
  if(draft) formData.value.is_draft = draft
  if(formData.value.email_id) {
    reply(draft)
  }else {
    sendMail(draft)
  }
}

function loadData() {
  store.dispatch('mails/loadSignatures')
  store.dispatch('mails/loadActiveSignatures')
}

onMounted(() => {
  loadData()
})
</script>

<style scoped>
.border_style {
  border: 2px solid var(--bs-light)
}
.modal-dialog,
.modal-content {
  overflow: visible !important;
}
.modal-content {
  overflow-x: auto;
}

.modal-body {
  min-width: 700px;
}
</style>